// extracted by mini-css-extract-plugin
module.exports = {"GoogleLogin":"styles_GoogleLogin__ZnXso","GoogleLogin-btn":"styles_GoogleLogin-btn__3RevF","GoogleLogin-btn-loading":"styles_GoogleLogin-btn-loading__x9T7k"};